import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../services/error-handle.service';
import { FailedRequestService } from '../services/failed-request.service';
import { SKIP_AUTH_ERROR_HANDLER } from './skip-auth-error.tokens';
import { SKIP_ERROR_TOAST, FALLBACK_ERROR_MESSAGE_KEY } from '../constants/constants';

export const customInterceptor: HttpInterceptorFn = (request, next) => {
    // Section: SERVICES / DEPENDENCIES
    //----------------------------------------------------------------------
    const errorHandlerService = inject(ErrorHandlerService);
    const failedRequestService = inject(FailedRequestService);

    const accessToken = localStorage.getItem('accessToken');

    const authReq = accessToken
        ? request.clone({
              withCredentials: true,
              headers: request.headers.set('Authorization', `Bearer ${accessToken}`)
          })
        : request;

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            failedRequestService.setFailedData(authReq, error);
            const skipAuthErrorHandler = authReq.context.get(SKIP_AUTH_ERROR_HANDLER);
            const skipToastErrorHandler = authReq.context.get(SKIP_ERROR_TOAST);
            const fallbackErrorMsgKey = authReq.context.get(FALLBACK_ERROR_MESSAGE_KEY);

            errorHandlerService.handle(error, skipAuthErrorHandler, skipToastErrorHandler, fallbackErrorMsgKey);
            return throwError(() => error);
        })
    );
};
